export enum RecordOptionPath {
  Both = '/record/Record_Both',
  Screen = '/record/Record_Screen',
  Cam = '/record/Record_Cam',
}

export const EXTERNAL_VIDEO_PREFIX = '~~~external-video~~~';
